import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import Avatar from "../../../Basic/Avatar";
import { uploadAvatar, deleteAvatar } from "../../api";
import { userData } from "../data";
var prefix = "sfx-react-ui-user-profile";

var UserImage = /*#__PURE__*/function (_React$Component) {
  _inherits(UserImage, _React$Component);

  var _super = _createSuper(UserImage);

  function UserImage() {
    var _this;

    _classCallCheck(this, UserImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      avatarWidth: 200
    });

    _defineProperty(_assertThisInitialized(_this), "upLoadImg", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blobImg) {
        var formData, uploadAvatarSuccess, _yield$uploadAvatar, data;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                formData = new FormData();
                formData.append("file", blobImg);
                uploadAvatarSuccess = _this.props.options.uploadAvatarSuccess;
                _context.prev = 3;
                _context.next = 6;
                return uploadAvatar(formData);

              case 6:
                _yield$uploadAvatar = _context.sent;
                data = _yield$uploadAvatar.data;

                if (uploadAvatarSuccess) {
                  uploadAvatarSuccess(data.url);
                }

                if (_this.props.uploadAvatarSuccess) {
                  _this.props.uploadAvatarSuccess(data.url);
                }

                return _context.abrupt("return", true);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](3);
                console.log(_context.t0);
                return _context.abrupt("return", false);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 13]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "deleteImg", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var deleteAvatarSuccess;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              deleteAvatarSuccess = _this.props.options.deleteAvatarSuccess;
              _context2.prev = 1;
              _context2.next = 4;
              return deleteAvatar();

            case 4:
              if (deleteAvatarSuccess) {
                deleteAvatarSuccess();
              }

              if (_this.props.deleteAvatarSuccess) {
                _this.props.deleteAvatarSuccess();
              }

              return _context2.abrupt("return", true);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);
              console.log(_context2.t0);
              return _context2.abrupt("return", false);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "onStateChange", function (state) {
      if (state === "edit") {
        _this.props.setDisableState(true);
      } else {
        _this.props.setDisableState(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getAvatarWidth", function () {
      var _dom = document.getElementById("myProfileImage");

      if (!_dom) return;
      var avatarWidth = _dom.clientWidth * 0.4 - 15;

      _this.setState({
        avatarWidth: avatarWidth > 200 ? 200 : avatarWidth
      });
    });

    return _this;
  }

  _createClass(UserImage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getAvatarWidth();
      window.addEventListener("resize", this.getAvatarWidth);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.getAvatarWidth);
    }
  }, {
    key: "render",
    value: function render() {
      var avatarWidth = this.state.avatarWidth;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefix, "-user-image-wrap"),
        id: "myProfileImage"
      }, /*#__PURE__*/React.createElement(Avatar, {
        width: avatarWidth,
        height: avatarWidth,
        upLoadImg: this.upLoadImg,
        deleteImg: this.deleteImg,
        currentImg: userData.userImg,
        state: this.onStateChange,
        readonly: !!(avatarWidth < 170)
      }));
    }
  }]);

  return UserImage;
}(React.Component);

export { UserImage as default };